import { Type } from "class-transformer";
import { ProjectType } from "./ProjectType";
import { ProjectTemplateField } from "./ProjectTemplateField";

export class ProjectTemplate {
    //netgen start
    title: string;
    typeId: number = null;
    @Type(() => ProjectType)
    type: ProjectType;
    description: string;
    @Type(() => ProjectTemplateField)
    fields: ProjectTemplateField[];
    id = 0;
    //netgen end
}
